import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginModule } from '@app/auth/login/login.module';
import {AuthGuard} from "@app/auth/auth.guard";
import {ResetPasswordModule} from "@app/auth/reset-password/reset-password.module";

@NgModule({
  imports: [
    CommonModule,
    LoginModule,
    ResetPasswordModule
  ],
  declarations: [],
  providers: [AuthGuard]
})
export class AuthModule { }
